// extracted by mini-css-extract-plugin
export default {"collectionsList":"CollectionsList_collectionsList__lrdgn","emptyTitle":"CollectionsList_emptyTitle__NaSQd","collectionsEmptyContent":"CollectionsList_collectionsEmptyContent__kqzod"};